import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import VideoTracker from './pages/VideoTracker';

function App() {
  return (
    <HashRouter>
      <div className="min-h-screen bg-slate-50 text-slate-900 font-sans selection:bg-blue-200">
        <Routes>
          <Route path="/" element={<VideoTracker />} />
        </Routes>
      </div>
    </HashRouter>
  );
}

export default App;